import React from 'react';
import { useLocation } from 'react-router-dom';
import ErrorPage from '../../components/ErrorPage';

function NotFound() {
  const location = useLocation();
  const pathHint = location.state?.from || location.pathname;

  return (
    <ErrorPage
      code="404"
      title="页面未找到"
      message="您访问的地址不存在，可能已被移动或删除。"
      pathHint={pathHint !== '/404' ? pathHint : undefined}
    />
  );
}

export default NotFound;
